// https://admin.shopify.com/store/ffstg/apps/delete-me-1/installation

export const deleteAccount = async (element) => {
  const xmlHttp = new XMLHttpRequest()
  const {
    email,
    customerId,
    customerDeleteConfirmation,
    redirectionUrl,
    customerDeleteGlobalError,
    customerSubscribedError,
  } = element.dataset
  const x = confirm(customerDeleteConfirmation)

  if (x) {
    const customerInfo = JSON.stringify({
      delete_id: customerId,
      delete_email: email,
    })

    xmlHttp.onload = function () {
      if (xmlHttp.status == 200) {
        const logoutBtn = document.querySelector("a[href='/account/logout']")
        if (logoutBtn) {
          logoutBtn.addEventListener('click', function () {
            const xmlhttpLogout = new XMLHttpRequest()
            xmlhttpLogout.setRequestHeader('Access-Control-Allow-Headers', '*')

            xmlHttp.onload = function () {
              if (xmlhttpLogout.readyState == XMLHttpRequest.DONE) {
                if (xmlhttpLogout.status == 200) {
                  window.location.href = redirectionUrl
                } else {
                  console.error('Error trying to logout')
                  alert(customerDeleteGlobalError)
                }
              }
            }

            xmlhttpLogout.open('get', '/account/logout')
            xmlhttpLogout.send()
          })
          logoutBtn.click()
        } else {
          location.href = '/account/logout'
        }
      } else {
        if (xmlHttp.responseText.includes('Customer Subscribed')) {
          alert(customerSubscribedError)
        } else {
          alert(customerDeleteGlobalError)
        }
      }
    }
    xmlHttp.open('post', '/apps/deleteme/customer-delete')
    xmlHttp.setRequestHeader('Content-Type', 'application/json')
    xmlHttp.send(customerInfo)
  } else {
    return
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const deleteAccountButton = document.getElementById('delete-account-button')

  if (deleteAccountButton) {
    deleteAccountButton.addEventListener('click', function (event) {
      event.preventDefault()
      deleteAccount()
    })
  }
})
